import {defineMessages} from 'react-intl';

export default defineMessages({
	title: {
		id: 'returnAuthCreateForm.step3.title',
		defaultMessage: 'Thank you! Your return request has been received.',
	},
	emailInstructions: {
		id: 'returnAuthCreateForm.step3.emailInstructions',
		defaultMessage: 'Confirmation with instructions will be emailed to you shortly.',
	},
	instruction1: {
		id: 'returnAuthCreateForm.step3.detailInstruction1',
		defaultMessage: 'Prepare the package and send it using the return label found inside.',
	},
	instruction2: {
		id: 'returnAuthCreateForm.step3.detailInstruction2',
		// eslint-disable-next-line max-len
		defaultMessage: 'Once we receive your package, we will process the return, either refunding the returned products or replacing them with others you have selected.',
	},
	instruction3: {
		id: 'returnAuthCreateForm.step3.detailInstruction3',
		defaultMessage: 'If you have made and exchange, you will find a new order in your order history.',
	},
	continueButton: {
		id: 'returnAuthCreateForm.step3.continueButton',
		defaultMessage: 'Continue shopping',
	},
});
